import { useState, useCallback } from 'react';

export function useFavourites() {
  const [favourites, setFavourites] = useState(() => {
    try { return JSON.parse(localStorage.getItem('arbauto_favourites')) || []; }
    catch { return []; }
  });

  const [showFavourites, setShowFavourites] = useState(false);

  const toggleFavourite = useCallback((oppId) => {
    setFavourites(prev => {
      const next = prev.includes(oppId) ? prev.filter(id => id !== oppId) : [...prev, oppId];
      localStorage.setItem('arbauto_favourites', JSON.stringify(next));
      return next;
    });
  }, []);

  return { favourites, showFavourites, setShowFavourites, toggleFavourite };
}
